import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from '../Homepage/HomePageMain.module.css';
import NonFictional from './NonFictional';
import Footer from '../common/UI/Footer';
import { useCategories } from '../hooks/categories/useCategories';
import Loading from '../common/HousGlass Loader/Loading';
import OverlayHome from '../Homepage/components/OverlayHome';
import { Helmet } from 'react-helmet';
import { getPageMetaById } from '../api/PageMetaManager';

function ShortsStories() {
  const { language } = useParams();
  const [dataAudio, setDataAudio] = useState('');

  const [meta, setMeta] = useState({
    title: "",
    description: "",
    keywords: ""
  });

  useEffect(() => {
    const fetchMeta = async () => {
      try {
        const data = await getPageMetaById(2);
        setMeta({
          title: data.meta_title?.trim() || '',
          description: data.meta_description?.trim() || '',
          keywords: data.meta_keywords?.trim() || '',
        });
      } catch (error) {
        console.warn("Meta not found for page 2, using defaults");
        // Fallback to default values
        setMeta({
          title: 'Short Stories - SunoKahaniyan',
          description: 'Explore a variety of short stories in audio format across different languages on SunoKahaniyan.',
          keywords: 'audio stories, ebooks, videos, hindi kahaniyan, suno kahaniyan',
        });
      }
    };

    fetchMeta();
  }, []);

  const {
    categories,
    isLoading,
    isError,
    error,
  } = useCategories('Audio', language || 'hindi');

  // Set audio category key based on language
  useEffect(() => {
    const languageMap = {
      hindi: 'HindiShortAudios',
      english: 'EnglishShortAudios',
      garhwali: 'GarhwaliShortAudios',
      kumaoni: 'KumaoniShortAudios',
    };
    setDataAudio(languageMap[language] || '');
  }, [language]);

  // Loading state
  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-[300px]">
        <Loading />
      </div>
    );
  }

  // Error state
  if (isError) {
    return (
      <div className="p-5 text-center text-red-500">
        Error loading categories: {error?.message || 'An unknown error occurred'}
      </div>
    );
  }

  // No categories
  if (!categories || categories.length === 0) {
    return (
      <>
        <div className="p-5 text-center">
          No categories found. Please try again later.
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>{meta.title?.trim() || 'Short Stories - SunoKahaniyan'}</title>
        <meta
          name="description"
          content={
            meta.description?.trim() ||
            'Explore a variety of short stories in audio format across different languages on SunoKahaniyan.'
          }
        />
        <meta
          name="keywords"
          content={
            meta.keywords?.trim() ||
            'audio stories, ebooks, videos, hindi kahaniyan, suno kahaniyan'
          }
        />
      </Helmet>

    <div className={styles.homeBackground}>
      <OverlayHome type={dataAudio} category="audio" />
          <div className={`${styles.homepageContainer} ${styles.contentOverlap}`}>
      
      <NonFictional
        categories={categories.map(({ id, name, slug }) => ({ id, name, slug }))}
      />
      <Footer />
      </div>
    </div>
    </>
  );
}

export default ShortsStories;
